import { createMuiTheme } from '@material-ui/core/styles';

const defaultTheme = createMuiTheme();
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#E1284C',
    },
    secondary: {
      main: '#333',
    },
    divider: '#E1284C',
  },
  typography: {
    h2: {
      fontSize: 24,
      lineHeight: '30px',
    },
    body1: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 'normal',
    },
    subtitle1: {
      fontSize: 14,
      lineHeight: '20px',
    },
  },
  shape: {
    borderRadius: 0,
  },
  overrides: {
    MuiFormHelperText: {
      root: {
        '&:first-letter': {
          textTransform: 'capitalize',
        },
      },
    },
    MuiInputBase: {
      input: {
        textAlign: 'left',
        color: '#333',
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 11,
        lineHeight: '13px',
      },
    },
    MuiLink: {
      root: {
        fontSize: 11,
        lineHeight: '13px',
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
      },
    },
    MuiCssBaseline: {
      '@global': {
        'html, body, #root': {
          height: '100%',
        },
        [defaultTheme.breakpoints.up('md')]: {
          'html, body, #root': {
            height: '100%',
          },
        },
      },
    },
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/constants/theme.js